mutation RenameTorahColumnOverlay($id: ID!, $name: String!) {
  renameTorahColumnOverlay(id: $id, name: $name) {
    ok
    errors
  }
}
